import {useUserStore} from '@common/stores';
import {format} from 'date-fns';
import {de, fr, es} from 'date-fns/locale';

// Utility function to convert a month number to a month name
export function useGetFullMonthNameAndYear(date: Date): string {
    const formattedLocale = useFormatLocale();
    const monthName = capitalize(format(date, 'MMMM', {locale: formattedLocale}));
    const year = date.getFullYear();

    return `${monthName} ${year}`;
}

export function useGetFullFormattedDate(date: Date): string {
    const formattedLocale = useFormatLocale();
    return capitalize(format(date, 'PPP', {locale: formattedLocale}));
}

export function useGetShortMonthNameWithDay(date: Date): string {
    const formattedLocale = useFormatLocale();
    return format(date, 'MMM d', {locale: formattedLocale});
}

export function useGetWeekdayName(date: Date): string {
    const formattedLocale = useFormatLocale();
    return format(date, 'EEEE', {locale: formattedLocale});
}

function capitalize(value: string) {
    return value.replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase());
}

export function useFormatLocale() {
    const locale = useUserStore().userLocale;
    const lang = locale.split('-')[0] ?? ['en'];
    switch (lang) {
        case 'de':
            return de;
        case 'fr':
            return fr;
        case 'es':
            return es;
        default:
            return undefined; // Let use the default enUS locale
    }
}
